import styles from "./Button.module.css";

export function Button({
  onClick,
  children,
  className = "",
  type = "button",
  disabled = false,
  variant = "primary",
  size,
  fullWidth = false,
}) {
  const classes = [
    styles.button,
    variant === "primary" ? styles.primary : null,
    variant === "ghost" ? styles.ghost : null,
    size === "small" ? styles.small : null,
    fullWidth ? styles.wide : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      onClick={onClick}
      className={classes}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
